export const LOGIN = 'api/auth/login';
export const DASHBOARDS = (customer_id) => `api/customer/${customer_id}/dashboards`;
export const KEYS = 'api/plugins/telemetry/DEVICE/6af8ac60-2694-11ec-a672-6d7dc2c7af58/values/timeseries?';